import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import stringUtils from "../../../_services/string-utils";

const OttoPostInstallHandler = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const state = searchParams.get("state");
        if (!stringUtils.isBlank(state)) {
            window.location.href =
                process.env.REACT_APP_OTTO_AUTHORIZATION_LINK +
                "&redirect_uri=" +
                process.env.REACT_APP_API_BASE_URL +
                "/oauth/otto/connect" +
                "&state=" +
                encodeURIComponent(state);
        }
    }, [searchParams]);

    return null;
};

export default OttoPostInstallHandler;
